import {css} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {springMotionTransition} from "../../../../constants/spring_motion_transition";

export const HomeMatchSentLeadMessage = ({isSentLeadMessageVisible, isLoading = false}: {isSentLeadMessageVisible: boolean; isLoading?: boolean}) => {
    return (
        <AnimatePresence>
            {isSentLeadMessageVisible && (
                <motion.div
                    className={sentLeadMessageStyles}
                    data-testid={KM_HM_TEST_IDS.SENT_LEAD_MESSAGE}
                    animate={{
                        opacity: isSentLeadMessageVisible ? 1 : 0,
                        display: isSentLeadMessageVisible ? "flex" : "none"
                    }}
                    transition={springMotionTransition}
                >
                    <BrandCheckboxCheckedIcon size="3.6" wrapperSize="3.6" wrapperColor="var(--colors-primary)" />
                    <Text variant="headline_6">Deweloper wkrótce skontaktuje się z Tobą aby opowiedzieć Ci więcej o tej ofercie</Text>
                    {isLoading && <Loader size="sm" className={loaderStyles} />}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

const sentLeadMessageStyles = css({
    alignItems: "center",
    gap: 1,
    opacity: 0,
    backgroundColor: "var(--colors-success)",
    width: "100%",
    paddingX: 2,
    paddingY: 4,

    md: {
        paddingX: 4
    }
});

const loaderStyles = css({
    opacity: 0.3
});
import {css} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {springMotionTransition} from "../../../../constants/spring_motion_transition";

export const HomeMatchSentLeadMessage = ({isSentLeadMessageVisible, isLoading = false}: {isSentLeadMessageVisible: boolean; isLoading?: boolean}) => {
    return (
        <AnimatePresence>
            {isSentLeadMessageVisible && (
                <motion.div
                    className={sentLeadMessageStyles}
                    data-testid={KM_HM_TEST_IDS.SENT_LEAD_MESSAGE}
                    animate={{
                        opacity: isSentLeadMessageVisible ? 1 : 0,
                        display: isSentLeadMessageVisible ? "flex" : "none"
                    }}
                    transition={springMotionTransition}
                >
                    <BrandCheckboxCheckedIcon size="3.6" wrapperSize="3.6" wrapperColor="var(--colors-primary)" />
                    <Text variant="headline_6">Deweloper wkrótce skontaktuje się z Tobą aby opowiedzieć Ci więcej o tej ofercie</Text>
                    {isLoading && <Loader size="sm" className={loaderStyles} />}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

const sentLeadMessageStyles = css({
    alignItems: "center",
    gap: 1,
    opacity: 0,
    backgroundColor: "var(--colors-success)",
    width: "100%",
    paddingX: 2,
    paddingY: 4,

    md: {
        paddingX: 4
    }
});

const loaderStyles = css({
    opacity: 0.3
});
